import React, { useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import useScrollStore from '../../../common/store/useScrollStore';
import Logo, { Wrapper as _Logo } from '../Logo';
import data from '../data';
import Link, { Wrapper as _Link } from './Link';
import useAnimation from './useAnimation';

const Wrapper = styled.nav(({ $display }: { $display: boolean }) => `
  position: fixed;
  z-index: 9;
  left: 0;
  top: 0;

  height: 100vh;
  width: 70rem;
  max-width: 100rem;

  display: ${$display ? "flex" : "none"};
  align-items: center;
  justify-content: center;

  ${_Link} { opacity: 0 }
`);

const LogoContainer = styled.div`
  opacity: 0;
  cursor: pointer;

  ${_Logo} {
    position: fixed;
    top: 25rem;
    left: 30rem;

    width: 7vw;
    max-width: 80rem;
  }
`;

const SideNav = ({ display }: { display: boolean }) => {
  /**
   * Hooks
   */
  const scrollTo = useScrollStore(useCallback(state => state.scrollTo, []));

  const logo = useRef<HTMLDivElement>(null);
  const circle = useRef<SVGSVGElement>(null);
  const link = useRef<HTMLDivElement[]>([]);

  const section = useAnimation(logo, circle, link);

  useEffect(() => {
    link.current.length = data.length;
  }, []);

  /**
   * Not hook
   */
  const handleLogoClick = () => {
    scrollTo && scrollTo(0, false);
  }

  /**
   * Render
   */
  return (
    <Wrapper $display={display}>
      <LogoContainer
        ref={logo}
        onClick={handleLogoClick}
      >
        <Logo circleRef={circle} />
      </LogoContainer>

      <div>
        {data.map((item, i) =>
          <Link
            key={i}
            ref={(dom: HTMLDivElement) => link.current[i] = dom}
            active={section - 2 === i}
            label={item.label}
            to={item.to}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default SideNav;